var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHeader)?_c('th',{domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":function($event){return _vm.orderBy(_vm.rowField, $event)}}}):_c('td',{staticClass:"vuetable-td-component-title"},[_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('small',[_vm._v(" "+_vm._s(_vm.contact)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }